import { includes } from "lodash";

const shareholderDetailsTabValues = [
  "overview",
  "transactions",
  "details",
  "commitments",
  "contributions",
  "options",
  "additional-representatives",
] as const;

export type ShareholderDetailsTab = (typeof shareholderDetailsTabValues)[number];

export const isShareholderDetailsTab = (s: unknown): s is ShareholderDetailsTab =>
  includes(shareholderDetailsTabValues, s);
